import React from 'react';
import { Text, Preset, Color } from '@lux/text';
import { Translate } from '@pegasus/translation';
import SubCategory from './SubCategory/SubCategory';
import * as S from './styles';
export var Category = function (_a) {
    var category = _a.category, toggleSelection = _a.toggleSelection, selectedCategoriesSet = _a.selectedCategoriesSet, availableCategoriesSet = _a.availableCategoriesSet, closeFilterModal = _a.closeFilterModal;
    if (!(category === null || category === void 0 ? void 0 : category.id)) {
        return null;
    }
    var isActive = selectedCategoriesSet.has(category.id);
    var onClick = function () {
        if (!selectedCategoriesSet.has(category.id)) {
            toggleSelection(category.id, 2);
            closeFilterModal();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Title, null,
            React.createElement(Text, { bold: true, preset: Preset.M }, category.name)),
        React.createElement(S.CategoryWrapper, null,
            React.createElement(S.Button, { "$isActive": isActive, onClick: onClick, type: "button", "aria-pressed": isActive },
                React.createElement(Text, { preset: Preset.S, bold: isActive, color: isActive ? Color.primary : Color.dark },
                    React.createElement(Translate, { message: "filters.allIn", params: {
                            category: category.name,
                        } }))),
            category.categories && (React.createElement(S.List, null, category.categories
                .sort(function (a, b) {
                return Number(availableCategoriesSet.has(b.id)) -
                    Number(availableCategoriesSet.has(a.id));
            })
                .map(function (subCategory) { return (React.createElement("li", { key: subCategory.id },
                React.createElement(SubCategory, { category: subCategory, toggleSelection: toggleSelection, selectedCategoriesSet: selectedCategoriesSet, availableCategoriesSet: availableCategoriesSet, closeFilterModal: closeFilterModal }))); }))))));
};
export default Category;
